import { Dates } from "src/modules/utils/shared/dates";
import { Strings } from "src/modules/utils/shared/strings";
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Map2 } from 'src/modules/utils/shared/map2.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { HttpConnectorError } from '../models/http-connector-error.model';
import { RestEndpoint } from '../models/rest-endpoint.model';
import { ErrorInformation } from '../shared/error-information.model';
import { Config } from 'src/modules/app-template/models/config.model';
import { UserInteractionItem } from 'src/modules/utils/misc/user-interaction-item.model';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Objects } from "src/modules/utils/shared/objects";

@Injectable()
export class ErrorHandlingService {

    app = inject(MainAppService);
    router = inject(Router);

    reportCount = new Map2<number, number>();
    lastBackendErrorDate: Date = null;

    reportToBackend(errorx: Error, backendErrorId?: string): void {
        if (!Utils.isNoe(backendErrorId) && (!Config.get().backendV2 || this.lastBackendErrorDate != null && Dates.diffSeconds(this.lastBackendErrorDate, new Date()) < 60)) {
            return;
        }
        this.lastBackendErrorDate = new Date();
       
        let error = new ErrorInformation(errorx);
        let httpResponse: HttpErrorResponse;
        try {
            //Fehler in PrimeNG - kann aktuell nicht behoben werden und hat wohl auch keine großen Auswirkungen
            if (error.trace?.includes("at Splitter.onResize")) {
                return;
            }

            //Benutzer hat manuell ungültige URL eingegeben
            if (error.message.includes("NG04002") && this.app.userInteractionHistory.length >= 1 && this.app.userInteractionHistory.length <= 2 && this.app.userInteractionHistory[0].type == "URL") {
                return;
            }

            httpResponse = errorx instanceof HttpConnectorError ? errorx.response : null;
            let httpStatus = httpResponse?.status;
            if (httpStatus == null && error.message.startsWith("Uncaught (in promise): HttpErrorResponse: ")) {
                let errorMessage = Strings.removePrefix(error.message, "Uncaught (in promise): HttpErrorResponse: ");
                let o = Objects.fromJson(errorMessage);
                httpStatus = o.status as number;
                //BackendResponse
                if (httpStatus == 500 && o.error.startsWith("{\"items\":[")) {
                    return;
                }
            }

            //InternalServerError, wird schon über Backend-Error-Log geloggt
            if (httpStatus == 500) {
                return;
            }
            //Gateway Timeout
            if (httpStatus == 504) {
                return;
            }
            //Service Unavailable (z.B. Neustart des Dienstes)
            if (httpStatus == 503) {
                return;
            }
            //Bad Gateway (Server nicht erreichbar)
            if (httpStatus == 502) {
                return;
            }
            //Forbidden
            if (httpStatus == 403) {
                return;
            }
            //Unauthorized
            if (httpStatus == 401) {
                return;
            }
            
        }
        catch {
        }

        this.app.userInteractionHistory.push(new UserInteractionItem(new Date(), "ERROR", []));
        let errorDate = Dates.formatDefault(new Date());
        Utils.setTimerOnce(Utils.isNoe(backendErrorId) ? 5000 : 0, () => {
            if (!Utils.isNoe(error.trace)) {
                let key = Strings.hash(Strings.getSubstring(error.trace, 0, 1000));
                let reportCount = this.reportCount.get(key);
                if (reportCount == null) {
                    reportCount = 0;
                }
                if (reportCount >= 3) {
                    return;
                }
                this.reportCount.set(key, reportCount + 1);
            }
            error.additional.backendErrorId = backendErrorId;
            error.additional.rawError = Objects.toJson(errorx, true);
            error.additional.url = this.router.url;
            error.additional.userName = this.app.getUserName();
            error.additional.errorDate = errorDate;
            error.additional.loadedDate = this.app.loadedDate != null ? Dates.formatDefault(this.app.loadedDate) : "???";
            error.additional.frontendVersion = (window as any).frontendVersion ?? "???";
            error.additional.frontendVersionFromBackend = this.app.frontendVersionFromBackend;
            error.additional.backendVersion = this.app.backendVersion;
            error.additional.isDesktop = this.app.deviceDetector.isDesktop();
            error.additional.isMobile = this.app.deviceDetector.isMobile();
            error.additional.isTablet = this.app.deviceDetector.isTablet();
            error.additional.browser = this.app.deviceDetector.browser();
            error.additional.browserVersion = this.app.deviceDetector.browser_version();
            error.additional.device = this.app.deviceDetector.device();
            error.additional.os = this.app.deviceDetector.os();
            error.additional.osVersion = this.app.deviceDetector.os_version();
            error.additional.userInteractionHistory = Arrays.reverse(Arrays.subList(Arrays.sort(this.app.userInteractionHistory), this.app.userInteractionHistory.length - 200, this.app.userInteractionHistory.length));

            if (Config.get().reportErrorsToBackend) {
                RestEndpoint.main().post().body(error).run("api/app/error-reporting");
            }
        });
    }
}